var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ele",
    d: "M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50ZM11.9996 50C11.9996 70.9871 29.0129 88.0004 50 88.0004C70.9871 88.0004 88.0004 70.9871 88.0004 50C88.0004 29.0129 70.9871 11.9996 50 11.9996C29.0129 11.9996 11.9996 29.0129 11.9996 50Z",
    fill: "#B6B8B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ele",
    d: "M50 24C35.622 24 24 35.622 24 50C24 64.378 35.622 76 50 76C64.378 76 76 64.378 76 50C76 35.622 64.378 24 50 24ZM63 59.334L59.334 63L50 53.666L40.666 63L37 59.334L46.334 50L37 40.666L40.666 37L50 46.334L59.334 37L63 40.666L53.666 50L63 59.334Z",
    fill: "#B6B8B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepError);
export default __webpack_public_path__ + "static/media/step-error.8627cfa038929b20c4ec086724529f31.svg";
export { ForwardRef as ReactComponent };